// extracted by mini-css-extract-plugin
export var locationCard = "_qn-0";